/**
 * Configurazione e utility per Stripe Elements
 * Funzioni pure per la gestione del componente sidebar-stripe
 */

/**
 * Ritorna lo stato iniziale/reset per il componente Stripe
 * @returns {Object} Oggetto con i valori di default
 */
export function get_initial_state() {
  return {
    stripe_error: '',
    stripe_elements: '',
    stripe_card_element: '',
    stripe_card_selector: '#card',
    stripe_intent_client_secret: '',
    stripe_payment_intent_id: '',
    stripe_form_complete: false,
  }
}

/**
 * Genera l'oggetto style per Stripe Card Element
 * @param {Function} sass - Funzione per ottenere variabili SCSS (this.sass)
 * @returns {Object} Configurazione style per stripe.elements().create("card")
 */
export function get_stripe_card_style(sass) {
  return {
    base: {
      fontFamily: "'Source Sans Pro', sans-serif",
      '::placeholder': {
        color: sass('gray-600'),
        fontSize: '13px',
      },
    },
    complete: {
      color: sass('success'),
    },
    invalid: {
      color: sass('danger'),
    },
  }
}

/**
 * Costruisce l'oggetto payment_method per stripe.confirmCardPayment()
 * @param {Object} card_element - Stripe Card Element
 * @param {string} name - Nome intestatario carta
 * @returns {Object} Oggetto payment_method
 */
export function build_payment_method(card_element, name) {
  return {
    payment_method: {
      card: card_element,
      billing_details: {
        name,
      },
    },
  }
}

/**
 * Formatta il payload per l'emit di conferma con successo
 * @param {string} paymentIntentId - ID del PaymentIntent Stripe
 * @param {string} name - Nome intestatario carta
 * @returns {Object} Payload per emit 'stripe-confirm'
 */
export function format_confirm_success(paymentIntentId, name) {
  return {
    name: 'stripe-confirm',
    payload: {
      error: false,
      paymentIntentId,
      name,
    },
  }
}

/**
 * Formatta il payload per l'emit di conferma con errore
 * @param {Object} error - Oggetto errore da Stripe
 * @returns {Object} Payload per emit 'stripe-confirm'
 */
export function format_confirm_error(error) {
  return {
    name: 'stripe-confirm',
    payload: {
      error: true,
      result: {
        ...error,
        status: 'stripe_error',
      },
    },
  }
}
